import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

const loadProjects = (params) => {
  const query = params

  return axios.get(API_URL + '/ctmproject', {
    params: query,
  })
}

const loadOwnEnterpriseProjects = (params) => {
  const query = params

  return axios.get(API_URL + '/ctmproject/searchownenterprise', {
    params: query,
  })
}

const loadProject = (idproject) => {
  return axios.get(API_URL + '/ctmproject', {
    params: {
      querysearch: `idproject:eq(${idproject})`,
      fetch: [
        'idfundingpkgmaster.idlender',
        'idsigner.idadministrator',
        'idcustomer.idprovisional.iduser',
        'idcustomer.idaddress',
        'idmerchant.identerprise.idoperator.iduser',
        'idmerchant.iduser',
        'idopportunity.idmerchant',
        'idopportunity.idprovisionalcustomer',
      ],
    },
  })
}

const changeState = (project) => {
  return axios.post(API_URL + '/ctmproject/changestatusproject', project)
}

const checkPocketSufficient = (idproject, idsigner) => {
  return axios.get(API_URL + '/ctmproject/pocketsufficient', {
    params: { idproject, idsigner },
  })
}

const requestcancel = (request) => {
  return axios.post(API_URL + '/ctmproject/requestcancel', request)
}

const cancel = (request) => {
  return axios.post(API_URL + '/ctmproject/cancel', request)
}

const restorecancel = (project) => {
  return axios.post(API_URL + '/ctmproject/restorecancel', project)
}

const resetCancellation = (project) => {
  return axios.post(API_URL + '/ctmproject/resetcancel', project)
}

const resend = (token, project) => {
  return axios.post(API_URL + '/ctmproject/sendsmsclient/' + project.idproject, project)
}

const resendAux = (project) => {
  return axios.post(API_URL + '/ctmproject/sendsmsclient/' + project.idproject, project)
}

const saveDataProject = (dataChangeProject) => {
  return axios.put(API_URL + '/ctmcustomer', dataChangeProject)
}

const projectByHash = (code) => {
  return axios.get(API_URL + '/ctmproject/iframe', { params: { code } })
}

const validatelender = (project) => {
  return axios.post(API_URL + '/ctmproject/validatelender', project)
}

const signmerchancontract = (project, file) => {
  return axios.post(API_URL + '/ctmproject/signmerchancontract', {
    pntFileSoa: file,
    ctmProjectSoa: project,
  })
}

const createProject = (provisional) => {
  return axios.post(API_URL + '/ctmproject/createproject', provisional)
}

const getHistory = (idproject) => {
  return axios.get(API_URL + '/ctmproject/gethistory/' + idproject)
}

export const downloadCsvProjects = (reportRequest) => {
  return axios.post(API_URL + '/ctmproject/download', reportRequest)
}

const assignMerchant = (params) => {
  return axios.put(API_URL + '/ctmproject/assignmerchant', params)
}

const annotationProject = (project) => {
  return axios.put(API_URL + '/ctmproject/annotations', project)
}

export const api = {
  loadProjects,
  loadOwnEnterpriseProjects,
  loadProject,
  changeState,
  checkPocketSufficient,
  requestcancel,
  restorecancel,
  cancel,
  resetCancellation,
  resend,
  resendAux,
  saveDataProject,
  projectByHash,
  validatelender,
  signmerchancontract,
  createProject,
  getHistory,
  downloadCsvProjects,
  assignMerchant,
  annotationProject,
}

export default api
